var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('article', [_c('activity-stage', [_c('template', {
    slot: "instructions"
  }, [_vm._t("instructions")], 2), _c('article', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('assessment-helper'), _c('section', {
    attrs: {
      "id": "paragraph-container"
    }
  }, [_c('blinking-cursor-text', {
    attrs: {
      "text": _vm.currentRound.paragraph,
      "text-step": _vm.progress.roundIndex
    }
  })], 1)], 1)], 2), _vm._t("keyboard")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }